import FlightSection from './FlightSection/FlightSection'
import { Slider } from 'src/components'
import { t } from 'i18next'
import { useIsMobile } from 'src/utils'

const SearchSection = ({ setState }: any) => {
  const isMobile = useIsMobile()
  const classes = [
    'w-full',
    'bg-white',
    'p-[20px]',
    'pb-[40px]',
    isMobile ? 'rounded-b-[8px]' : 'rounded-[8px]',
  ]
  return (
    <div className={classes.join(' ')}>
      <div className='heading-2 text-black mb-[20px]'>{t('search.title')}</div>
      <Slider
        {...{
          components: [
            {
              element: <FlightSection {...{ setState }} />,
              name: t('global.flight'),
            },
            {
              element: <FlightSection {...{ setState }} />,
              name: t('global.flight'),
            },
          ],
        }}
      />
    </div>
  )
}

export default SearchSection
